import { render, staticRenderFns } from "./TikQModal.vue?vue&type=template&id=f6d30114&scoped=true&"
import script from "./TikQModal.vue?vue&type=script&lang=js&"
export * from "./TikQModal.vue?vue&type=script&lang=js&"
import style0 from "./TikQModal.vue?vue&type=style&index=0&id=f6d30114&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d30114",
  null
  
)

export default component.exports